import { Action } from '@ngrx/store';
import { UsuarioEscenario } from 'src/app/models/SicarMap/Escenario/UsuarioEscenario.model';


export enum DUSTypes {
  SCENE_DU = '[SCENE] DeleteUsr',
  SCENE_DUSUCCESS = '[SCENE] DUsrSuccess',
  SCENE_DUFAILURE = '[SCENE] DUsrFailure',
  SCENE_DURESET = '[SCENE] DUsrReset ',
}

export class DUSReset implements Action {
  readonly type = DUSTypes.SCENE_DURESET;
  constructor() {}
}
export class DUScene implements Action {
  readonly type = DUSTypes.SCENE_DU;
  constructor(public claveRUS: number) {}
}

export class DUSSuccess implements Action {
  readonly type = DUSTypes.SCENE_DUSUCCESS;
  constructor(public claveRUS: number) {}
}

export class DUSFailure implements Action {
  readonly type = DUSTypes.SCENE_DUFAILURE;
  constructor(public payload: any) {}
}


export type DUSAcciones =
  | DUScene
  | DUSSuccess
  | DUSFailure
  | DUSReset;